import React from 'react'

const TagBadge = ({tag}) => {
  return (
    <span className="badge badge-light mr-3 mt-2 text-white" role="button">{tag}</span>
  );
}

export default TagBadge